import {
  SliderNavMod,
  SliderWithArrows,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { Image } from '~components/Image/Image';
import { Markdown } from '~components/Markdown';
import { NextImage } from '~components/NextImage/NextImage';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockImages.module.scss';
import { ContentBlockImagesProps } from './ContentBlockImages.types';

export function ContentBlockImages({
  files,
  ...sectionProps
}: ContentBlockImagesProps) {
  if (!files.length) return null;

  return (
    <ContentBlockWrapper {...sectionProps}>
      <article>
        {files.length === 1 && files[0].image ? (
          <figure className={styles.media}>
            <Image
              className={styles.image}
              {...files[0].image}
              alt={files[0].description}
            />
            {files[0].description && (
              <figcaption className={styles.description}>
                <Typography
                  tagName={TypographySizes.span}
                  mods={[TypographyMods.bodyM]}
                >
                  <Markdown markdownString={files[0].description} />
                </Typography>
              </figcaption>
            )}
          </figure>
        ) : (
          <SliderWithArrows
            navMod={SliderNavMod.light}
            contentClassName={styles.slides}
          >
            {files.map((file, key) => (
              <figure key={key} className={styles.media}>
                <NextImage
                  className={styles.image}
                  {...file.image}
                  alt={file.description}
                />
                <figcaption className={styles.description}>
                  <Markdown markdownString={file.description} />
                </figcaption>
              </figure>
            ))}
          </SliderWithArrows>
        )}
      </article>
    </ContentBlockWrapper>
  );
}
